module.exports = __webpack_public_path__ + "img/direction-1@2x.5982dfe7.png";